import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { Pencil, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaPlanoEditado = (acao: string): boolean => {
  const acaoLower = acao.toLowerCase().trim();
  return acaoLower === 'plano editado' || acaoLower.includes('plano editado');
};

const getIconPlanoEditado = (acao: string): { Icon: LucideIcon; color: string } => {
  return { Icon: Pencil, color: 'var(--c8041c7)' };
};

export default function CardPlanoEditado({ item, isExpanded, onToggleExpand }: CardHistoricoProps) {
  return (
    <CardHistoricoBase
      item={item}
      icon={getIconPlanoEditado(item.acao)}
      temExpansaoDisponivel={true}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      expandedContent={<ExpandedContent item={item} />}
      tituloCustomizado="Plano editado"
    />
  );
}

export const planoEditadoConfig = {
  tipo: 'plano_editado',
  detectaTipo: detectaPlanoEditado,
  getIcon: getIconPlanoEditado,
  temExpansao: () => true,
  Component: CardPlanoEditado
};
